define([], function() {
	
	var Fraud = {
			
		call : function(cybersourceEnabled, successCallback){
			console.log("CysEnabled "+cybersourceEnabled);
			if(typeof(fraudStatic) === 'undefined' || (cybersourceEnabled  && !fraudStatic.enabled)){
				successCallback();
			} else {		
				if(!fraudStatic.enabled){
					successCallback();
				}else{	
					if(sessionStorage.getItem('fraudStatic') === document.querySelector('input[name="deviceId"]').value)
					{
						successCallback();
					} else {
						sessionStorage.setItem('fraudStatic',document.querySelector('input[name="deviceId"]').value);
						_cc.push(['cag', successCallback]);
					}
				}
			}
		}

	}
	
	if (typeof window.COSTCO === 'undefined') {
		window.COSTCO = new Object();
	}
	window.COSTCO.Fraud = Fraud;
	return Fraud;
});


// WEBPACK FOOTER //
// ./js/checkout/fraud.js